__turbopack_context__.v({
  "backButton": "sHHTrq_backButton",
  "buttonsWrapper": "sHHTrq_buttonsWrapper",
  "divider": "sHHTrq_divider",
  "editOrderLabel": "sHHTrq_editOrderLabel",
  "emptyStateWrapper": "sHHTrq_emptyStateWrapper",
  "header": "sHHTrq_header",
  "orderNumber": "sHHTrq_orderNumber",
  "statusWrapper": "sHHTrq_statusWrapper",
  "wrapper": "sHHTrq_wrapper",
});
